<template>
  <sera-modal
    :open="open"
    @primary-action="handleConfirmed"
    @close="handleClose"
  >
    <template #header>
      <div>
        <h3 class="page-header-2">Archive Sub-Customers?</h3>
      </div>
    </template>
    <div style="max-width: 400px">
      <p class="mb-4">
        This customer has one or more sub-customers. They will also be archived.
      </p>
      <p class="mb-4">
        The system will first attempt to archive all sub-customers, once this
        process is complete, this customer will be archived.
      </p>
      <p class="mb-4">
        If you do not want them archived, first promote them to be top-level
        customers, or assign them to another parent.
      </p>
      <p class="mb-4">Do you wish to continue?</p>
    </div>
  </sera-modal>
</template>
<script setup lang="ts">
defineProps({
  open: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(["archive-confirmed", "close"]);

function handleConfirmed() {
  emit("archive-confirmed");
}

function handleClose() {
  emit("close");
}
</script>
